import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'PrintButton',
  setup(__props) {

const handleClick = () => {
  window.print()
}

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("a", {
    class: "print-button noprint",
    onClick: handleClick
  }, [
    _createElementVNode("small", null, [
      _createVNode(_component_FontAwesomeIcon, {
        class: "icon",
        icon: "print"
      }),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('general.print')), 1)
    ])
  ]))
}
}

})